import { Heart } from 'lucide-react';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';
import { useFavorites } from '@/store/useFavorites';

// Reusable heart toggle. Persists via the favorites store and shows a toast.
export const FavoriteButton = ({ id, size = 'md', className }) => {
  const isFavorite = useFavorites((s) => s.isFavorite(id));
  const toggle = useFavorites((s) => s.toggle);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const changed = await toggle(id);
    if (!changed) return;
    const nowFav = useFavorites.getState().isFavorite(id);
    toast(nowFav ? 'Added to favorites' : 'Removed from favorites', {
      description: nowFav ? 'View it anytime in your saved homes.' : undefined,
    });
  };

  const dims = size === 'lg' ? 'h-11 w-11' : 'h-9 w-9';
  const icon = size === 'lg' ? 20 : 16;

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      aria-pressed={isFavorite}
      data-testid="listing-card-favorite-button"
      className={cn(
        'grid place-items-center rounded-full bg-white/90 backdrop-blur border border-slate-200 shadow-sm transition-colors hover:bg-white focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-200',
        dims,
        className
      )}
    >
      <Heart
        size={icon}
        className={cn('transition-colors', isFavorite ? 'fill-rose-500 text-rose-500' : 'text-slate-600')}
      />
    </button>
  );
};
